module.exports = __webpack_public_path__ + "img/quest.35e71cb1.svg";